import React, { useState } from "react"
import { Badge } from "@shopify/polaris"
import Recommendation from "components/widgets/ImprovePage/Recommendation"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { PILLAR_ENVIRONMENTAL } from "utils/constants/pillars"
import WebsiteRecommendationTable from "components/widgets/WebsiteImprovePage/WebsiteRecommendationTable"
import WebsiteRecommendationDescription from "components/widgets/WebsiteImprovePage/WebsiteRecommendationDescription"

const occurrencesStatus = (occurrences, totalPages) => {
  if (!totalPages) return undefined

  const ratio = (occurrences / totalPages) * 100

  if (ratio > 80) return "critical"
  if (ratio > 40) return "warning"
  return "success"
}

const WebsiteRecommendation = ({ recommendation, totalPages }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const {
    impact,
    complexity,
    key,
    context,
    resources,
    details,
    occurrences,
    rgesn_criteria: rgesnCriteria = [],
    rgesn_theme: rgesnTheme,
    rgaa_criteria: rgaaCriteria = [],
    rgaa_category: rgaaCategory,
  } = recommendation

  const header = details?.header || []
  const rows = details?.rows || []
  const hasDetails = header.length > 0

  return (
    <>
      <Recommendation
        impact={impact}
        complexity={complexity}
        pillar={PILLAR_ENVIRONMENTAL}
        domain="website"
        recoKey={key}
        theme={context}
        objective={null}
        showDomainBadge={false}
        description={
          <WebsiteRecommendationDescription
            title={t(`recommendation:websites.audits.${key}.title`)}
            description={t(`recommendation:websites.audits.${key}.description`)}
          />
        }
        resources={resources}
        additionalBadges={
          <>
            {occurrences > 0 && (
              <Badge status={occurrencesStatus(occurrences, totalPages)}>
                {t('improve:websites.occurrences', { count: occurrences })}
              </Badge>
            )}
            <Badge>
              {t(`improve:recommendations_table.domain.${context}`)}
            </Badge>
            {context === 'eco_conception' && rgesnTheme && (
              <Badge>
                {t(`improve:websites.rgesn.theme.${rgesnTheme}`)}
              </Badge>
            )}
            {context === 'eco_conception' && rgesnCriteria.map((criterion) => (
              <Badge key={criterion}>
                {t('improve:websites.rgesn.criterion', { id: criterion })}
              </Badge>
            ))}
            {context === 'accessibility' && rgaaCategory && (
              <Badge>
                {t(`improve:websites.rgaa.category.${rgaaCategory}`)}
              </Badge>
            )}
            {context === 'accessibility' && rgaaCriteria.map((criterion) => (
              <Badge key={criterion}>
                {t('improve:websites.rgaa.criterion', { id: criterion })}
              </Badge>
            ))}
          </>
        }
        sdg={13}
        onSelectRecommendation={hasDetails ? () => setOpen(!open) : null}
        simulationPropositionLevers={hasDetails ? [{}] : null}
      />
      {hasDetails && (
        <WebsiteRecommendationTable open={open} header={header} rows={rows} />
      )}
    </>
  )
}

WebsiteRecommendation.propTypes = {
  recommendation: PropTypes.object.isRequired,
  totalPages: PropTypes.number,
}

export default WebsiteRecommendation
